const firebaseConfig = {
        apiKey: "AIzaSyCd2zb-bp9lvNxs81oa0sTwrXClZ1rDqfE",
        authDomain: "red-onione.firebaseapp.com",
        projectId: "red-onione",
        storageBucket: "red-onione.appspot.com",
        messagingSenderId: "639445621034",
        appId: "1:639445621034:web:baf254705189fa8dfba653",
        measurementId: "G-XNZ0Q70W36"
};

export default firebaseConfig;